import { render, staticRenderFns } from "./ComunicationForm.vue?vue&type=template&id=4af7449a&scoped=true"
import script from "./ComunicationForm.vue?vue&type=script&lang=js"
export * from "./ComunicationForm.vue?vue&type=script&lang=js"
import style0 from "./ComunicationForm.vue?vue&type=style&index=0&id=4af7449a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af7449a",
  null
  
)

export default component.exports